import { HIDE_COMPONENT_CAP } from './hide-component.capability';
import { RESTYLE_CAP } from './restyle.capability';
import { SHOW_COMPONENT_CAP } from './show-component.capability';
import { UPDATE_QUERY_PARAM_CAP } from './update-query-param.capability';
import { NAVIGATE_TO_CAP } from './navigate-to.capability';
import { RELOAD_PAGE_CAP } from './reload-page.capability';
import { TOGGLE_FULLSCREEN_MODE_CAP } from './toggle-fullscreen-mode.capability';
import { __NOOP_MOCK_CAP } from './internal/noop.capability';
export const capabilities = {
  SHOW_COMPONENT_CAP,
  HIDE_COMPONENT_CAP,
  RESTYLE_CAP,
  UPDATE_QUERY_PARAM_CAP,
  NAVIGATE_TO_CAP,
  RELOAD_PAGE_CAP,
  TOGGLE_FULLSCREEN_MODE_CAP,
  __NOOP_MOCK_CAP
};
export const nativeCapabilities = capabilities;
export { defineCapability, Capability } from './internal';